/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

//Toggles the loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

//sets the selected input to the redux store
export const setSearchInput = (data) => {
  return {
    type: ActionTypes.SET_SELECTED_INPUT_MONTHLY,
    payload: data,
  };
};

//set the request screen frod api data to store
export const setRequestScreenGrid = (data) => ({
  type: ActionTypes.SET_REQUEST_SCREEN_GRID_MONTHLY,
  payload: data,
});

// sets the right grid data of detail screen
export const setRightGridData = (data) => ({
  type: ActionTypes.SET_RIGHT_GRID_DATA_MONTHLY,
  payload: data,
});

//Refreshed the Store State
export const refreshMonthlyClaimReconcilliationState = () => ({
  type: ActionTypes.REFRESH_MONTHLY_CLAIMS_RECONCILLIATION_MONTHLY,
  payload: {},
});

// sets the left grid data of detail screen
export const setLeftGridData = (data) => ({
  type: ActionTypes.SET_LEFT_GRID_DATA_MONTHLY,
  payload: data,
});

//sets selected input value from first screen to detail screen to the redux store
export const selectedRequest = (data) => ({
  type: ActionTypes.SET_SELECTED_REQUEST_MONTHLY,
  payload: data,
});

//set Last Updated Userid And Count API data
export const setLastUpdatedUseridAndCount = (data) => ({
  type: ActionTypes.SET_LAST_UPDATED_USERID_AND_COUNT_MONTHLY,
  payload: data,
});

// set schedule meesgae data from API to redux store
export const setScheduleMessage = (data) => ({
  type: ActionTypes.SET_SCHEDULE_MESSAGE_MONTHLY,
  payload: data,
});

// API to get Request Screen Gridr Reports data
export const getRequestScreenGrid = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_MONTHLY_CLAIMS_RECONCILIATION, {})
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setRequestScreenGrid(
          response?.data?.monthlyClaimsReconciliationReportVO
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setRequestScreenGrid([]));
    });
};

// API to  get display screenleft grid data
export const getDisplayScreenLeftGrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_MONTHLY_CLAIMS_LEFT_SCREEN_GRID_REPORT, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setLeftGridData(
          response?.data?.monthlyClaimsReconciliationLeftGridReportVO
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setLeftGridData([]));
    });
};
// API to  get display screenleft grid data
export const getDisplayScreenRightGrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_MONTHLY_CLAIMS_RIGHT_SCREEN_GRID_REPORT, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setRightGridData(
          response?.data?.monthlyClaimsReconciliationRightGridReportVO
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setRightGridData([]));
    });
};

// API to  ge tLast Updated Userid And Count
export const getLastUpdatedUseridAndCount = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_LAST_UPDATED_USERID_AND_COUNT_FOR_MONTHLY, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setLastUpdatedUseridAndCount(
          response?.data?.monthlyClaimsReconciliationLastUpdatedUserCountVO ||
            'NoRequestExist'
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setLastUpdatedUseridAndCount(null));
    });
};
// API to get Monthly Claims Reconciliation Shedule
export const getMonthlyClaimsReconciliationShedule = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_MONTHLY_CLAIMS_RECONCILIATION_RUN_LATER, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setScheduleMessage(
          response?.data?.monthlyClaimsReconciliationRunLaterVO
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setScheduleMessage(null));
    });
};
